import clone from 'lodash/clone';
import mapValues from 'lodash/mapValues';

import {
  UPDATE_START_NEW_FORM,
  CLEAR_START_NEW_FORM,
} from '../actions/action-types';
import {
  FOIL,
  DEFAULT_INNER_COPPER_WEIGHT,
  DEFAULT_OUTER_COPPER_WEIGHT,
  DEFAULT_NUM_COPPER_LAYERS,
} from '../constants/globals';
import { validateAll, REQUIRED, EVEN_NUMBER } from '../lib/validation';

const initResin = {
  id: undefined,
  manufacturerId: undefined,
},
resinValidations = {
  id: [ REQUIRED ],
  manufacturerId: [ REQUIRED ]
},
formConfig = {
  projectName: {
    initValue: '',
    validations: [ REQUIRED ]
  },
  partNumber: {
    initValue: ''
  },
  stackupType:{
    initValue: FOIL,
    validations: [ REQUIRED ]
  },
  numberOfCopperLayers: {
    initValue: DEFAULT_NUM_COPPER_LAYERS,
    validations: [ EVEN_NUMBER ]
  },
  innerCopperWeight: {
    initValue: DEFAULT_INNER_COPPER_WEIGHT
  },
  outerCopperWeight: {
    initValue: DEFAULT_OUTER_COPPER_WEIGHT
  },
  resin: {
    initValue: initResin,
    validations: resinValidations
  }
};

function startNewForm(state = getInitialState(formConfig), action){
  switch(action.type){
    case UPDATE_START_NEW_FORM:
      return {
        ...state,
        [action.key]: action.value
      };
    case CLEAR_START_NEW_FORM:
      return getInitialState(formConfig);
    default:
      return state;
  }
}

function getInitialState(config) {
  return mapValues(config, o => clone(o.initValue));
}

export function getIsFormValid(state){
    return validateAll(state, formConfig).length === 0;
}

export function getManufacturerId(state){
  return state.resin.manufacturerId;
}

export function getResinId(state){
  return state.resin.id;
}

export function getFormConfig(){
  return formConfig;
}

export default startNewForm;



// WEBPACK FOOTER //
// ./src/reducers/startNewForm.js